import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { compareTo3ankvs086tmwq as compareTo } from './js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import { identityHashCode27r2jreowdkzk as identityHashCode } from './js/coreRuntime.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from './Comparable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var EnumClass;
function Enum() {
  if (EnumClass === VOID) {
    class $ {
      constructor(name, ordinal) {
        this.v1_1 = name;
        this.w1_1 = ordinal;
      }
      e5(other) {
        return compareTo(this.w1_1, other.w1_1);
      }
      d(other) {
        return this.e5(other instanceof Enum() ? other : THROW_CCE());
      }
      equals(other) {
        return this === other;
      }
      hashCode() {
        return identityHashCode(this);
      }
      toString() {
        return this.v1_1;
      }
    }
    initMetadataForClass($, 'Enum', VOID, VOID, [Comparable()]);
    EnumClass = $;
  }
  return EnumClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance13way2il9a8jt,
  Enum as Enum3alwj03lh1n41,
};
//endregion

//# sourceMappingURL=Enum.mjs.map
